// extracted by mini-css-extract-plugin
export default {"shimmerEffect":"Skeleton_shimmerEffect__kygtK","shimmer":"Skeleton_shimmer__qFo8d","likeAnimation":"Skeleton_likeAnimation__yKAzo"};